import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=3011178e&scoped=true&"
import script from "./standard.vue?vue&type=script&lang=ts&"
export * from "./standard.vue?vue&type=script&lang=ts&"
import style0 from "./standard.vue?vue&type=style&index=0&id=3011178e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011178e",
  null
  
)

export default component.exports